import type { ComponentProps } from 'react';
import { LordIcon } from './lord-icon';

export type ToastIconProps = ComponentProps<'div'> & {
  type: 'success' | 'error' | 'info' | 'warning';
  size?: number;
};

const ICON_CONFIGS = {
  success: {
    src: '/lordicons/check.json',
    colors: 'primary:#16a34a,secondary:#22c55e', // green colors
    trigger: 'in',
  },
  error: {
    src: '/lordicons/cross.json',
    colors: 'primary:#dc2626,secondary:#ef4444', // red colors
    trigger: 'in',
  },
  info: {
    src: '/lordicons/info.json',
    colors: 'primary:#2563eb,secondary:#3b82f6', // blue colors
    trigger: 'in',
  },
  warning: {
    src: '/lordicons/error.json',
    colors: 'primary:#d97706,secondary:#f59e0b', // orange colors
    trigger: 'in',
  },
};

export function ToastIcon({ type, size, className, ...props }: ToastIconProps) {
  const config = ICON_CONFIGS[type];

  return (
    <div className={`flex items-center justify-center ${className}`} {...props}>
      <LordIcon
        src={config.src}
        trigger={config.trigger as 'hover' | 'click' | 'loop' | 'morph' | 'in'}
        colors={config.colors}
        size={size}
      />
    </div>
  );
}
